/**
 * @module experience/order-payment
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

import { Payment } from '@support/api/proxies/requests/api-2614.interface';

export class PostValidationModel {
  /**
   * To store payment
   */
  private payment: Payment;
  /**
   * To store encrypted content
   */
  private encryptedContent: string;
  /**
   * To store track1 data
   */
  private track1Data: string;
  /**
   * To store track1 data
   */
  private track2Data: string;
  /**
   * To check termsAgreementIndicator
   */
  private termsAgreementIndicator: boolean;
  /**
   * To check TermsAndCondition
   */
  private termsAgreementTime: string;
  /**
   * To store customerType
   */
  private customerType: string;
  /**
   * To store customerType
   */
  private productGroup: string;
  /**
   * To store customerType
   */
  private programCode: string;
  /**
   * To store customerType
   */
  private orderTypes: string;
  /**
   * To store customerType
   */
  private accountId: string;
  /**
   * To store billerCode
   */
  private billerCode: string;
  /**
   * To store businessSegment
   */
  private businessSegment: string;
  /**
   * To store channel
   */
  private channel: string;
  /**
   * To store paymentChannelCode
   */
  private paymentChannelCode: string;
  /**
   * To store tempToken
   */
  private tempToken: string;
  /**
   * To store chargeAccountNumberIndicator
   */
  private chargeAccountNumberIndicator: string;
  /**
   * To store encryptionTarget
   */
  private encryptionTarget: string;
  /**
   * To store terminalType
   */
  private terminalType: string;
  /**
   * To check isStoreDigital
   */
  private isStoreDigital: boolean;

  constructor() {
    this.payment = this.setPayment();
    this.encryptedContent = '';
    this.track1Data = '';
    this.track2Data = '';
    this.termsAgreementIndicator = false;
    this.termsAgreementTime = '';
    this.customerType = '';
    this.productGroup = '';
    this.programCode = '';
    this.accountId = '';
    this.orderTypes = '';
    this.billerCode = '';
    this.businessSegment = '';
    this.channel = '';
    this.paymentChannelCode = '';
    this.tempToken = '';
    this.chargeAccountNumberIndicator = '';
    this.encryptionTarget = '';
    this.terminalType = '';
    this.isStoreDigital = false;
  }

  /**
   * Function to set payment
   * @returns Payment
   */
  private setPayment(): Payment {
    return this.payment;
  }
}
